import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router'
import Vuesax from 'vuesax3'
import 'vuesax3/dist/vuesax.css' //Vuesax styles
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import 'remixicon/fonts/remixicon.css';
import './assets/css/backend.css'
import './assets/css/developer.css'
import './assets/css/login.css'

import VueProgressBar from "@aacassandra/vue3-progressbar";
import Toaster from '@meforma/vue-toaster';


// import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JS
import store from './vuex/store'
import '@vueform/multiselect/themes/default.css'

import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'

// PWA Service Worker Registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

//main.js

const options = {
    color: "#c0b7fb",
    failedColor: "#000",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
};

const app = createApp(App)
app.use(router)
app.use(store)
app.use(ContextMenu)
app.use(Vuesax)
app.use(VueProgressBar, options)
app.use(Toaster)
app.mount('#app')